var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"whiteList",attrs:{"href":"http://www.cac.gov.cn/2021-10/18/c_1636153133379560.htm","target":"_blank"}},[_vm._v("稿源白名单")])])
}]

export { render, staticRenderFns }